function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.008 14.97l4.408-4.703a1.393 1.393 0 000-1.874A1.207 1.207 0 0017.532 8c-.332 0-.65.141-.884.393l-5.28 5.634c-.235.25-.368.59-.368.944s.133.694.368.943l5.28 5.7a1.206 1.206 0 001.768 0 1.393 1.393 0 000-1.873l-4.408-4.77z",
  id: "path-chevron-left"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#path-chevron-left",
  transform: "translate(-11 -8)",
  fillRule: "evenodd"
})));